import React from "react";
import PropTypes from "prop-types";

function CrmAccessDisclaimer({ crm }) {
  return (
    <div
      data-test="crm-access-disclaimer"
      style={{ textAlign: "center", paddingTop: "10px" }}
    >
      By clicking on &quot;Connect with {crm}&quot; you agree to grant Hubly
      access to the {crm} details outlined above.
    </div>
  );
}

CrmAccessDisclaimer.propTypes = {
  crm: PropTypes.string.isRequired,
};

export default CrmAccessDisclaimer;
